import { render, staticRenderFns } from "./CreatePostalModal.vue?vue&type=template&id=6bbe391e&scoped=true&"
import script from "./CreatePostalModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePostalModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostalModal.vue?vue&type=style&index=0&id=6bbe391e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe391e",
  null
  
)

export default component.exports